goog.provide('el8.appchart.dialog.referralCcda');

goog.require('el8.template.appchart.dialog.referralCcda');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.util.consts');
goog.require('el8.appservice.notifier');


el8.appchart.dialog.referralCcda = (function(){

    var that = new el8.uiwidget.FormDialog({
        title: 'Enter Recipient Name',
        modal: true,
        position: 'center',
        autoHeight: true,
        width: 350,
        contentFn: el8.template.appchart.dialog.referralCcda.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'firstName',
                selector: ':input[name="firstName"]'
            },
            {
                name: 'lastName',
                selector: ':input[name="lastName"]'
            }
        ]
    });

    form.addButton('save', 'Export', function() {
        el8.appservice.notifier.notify('Exporting...');
        var mapped = form.getMapped();
        var url = el8Globals.PATIENT_PATH + 'ccda/export/referral?'
            + encodeURIComponent('firstName') + '=' + encodeURIComponent(mapped['firstName'])
            + "&"
            + encodeURIComponent('lastName') + '=' + encodeURIComponent(mapped['lastName']);
        window.open(url);


    }, true);
    form.addCancelButton(function() {
        that.hide();
    }, false);
    that.setForm(form);


    return that;
})();
